import React, { useEffect, useRef, useState } from "react";
import "./home.css"
import { Link } from "react-router-dom";
import { FaArrowDown, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import logoBlue from "../images/logo/pwb-logo-blue.svg"
import bannerImage from "../images/banner.png";
import bannerImageOne from "../images/banner-1.png";
import bannerImageTwo from "../images/banner-2.png";
import bannerImageThree from "../images/banner-3.png";
import bannerImageFour from "../images/banner-4.png";
import bannerImageFive from "../images/banner-5.png";

const heroSlides = [
  {
    src: bannerImage,
    alt: "ครัวเชิงพาณิชย์พร้อมฮู้ดดูดควันและเตาสแตนเลส",
  },
  {
    src: bannerImageOne,
    alt: "ระบบครัวสแตนเลสพร้อมฮู้ดดูดควัน เตาแก๊ส และอ่างล้าง",
  },
  {
    src: bannerImageFive,
    alt: "ระบบครัวสแตนเลสพร้อมฮู้ดดูดควัน เตาแก๊ส และอ่างล้าง",
  },
  {
    src: bannerImageTwo,
    alt: "ระบบครัวสแตนเลสพร้อมฮู้ดดูดควัน เตาแก๊ส และอ่างล้าง",
  },
  {
    src: bannerImageThree,
    alt: "ระบบครัวสแตนเลสพร้อมฮู้ดดูดควัน เตาแก๊ส และอ่างล้าง",
  },
  {
    src: bannerImageFour,
    alt: "ระบบครัวสแตนเลสพร้อมฮู้ดดูดควัน เตาแก๊ส และอ่างล้าง",
  },
];

function Home() {
  const [heroSlide, setHeroSlide] = useState(0);
  const touchStartX = useRef(null);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setHeroSlide((slide) => (slide + 1) % heroSlides.length);
    }, 5500);

    return () => window.clearInterval(interval);
  }, []);

  const showPreviousSlide = () => {
    setHeroSlide((slide) => (slide === 0 ? heroSlides.length - 1 : slide - 1));
  };

  const showNextSlide = () => {
    setHeroSlide((slide) => (slide + 1) % heroSlides.length);
  };

  const handleTouchStart = (event) => {
    touchStartX.current = event.touches[0].clientX;
  };

  const handleTouchEnd = (event) => {
    if (touchStartX.current === null) return;

    const distance = touchStartX.current - event.changedTouches[0].clientX;
    if (Math.abs(distance) > 50) {
      if (distance > 0) {
        showNextSlide();
      } else {
        showPreviousSlide();
      }
    }
    touchStartX.current = null;
  };

  const scrollToSection = () => {
    const section = document.getElementById("services");
    if (section) {
      const offset = 80; // Adjust this value for extra spacing
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: sectionPosition - offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="home">

      <section className="home-hero">
        <div className="home-hero-copy">
          <p className="hero-kicker">STAINLESS STEEL FABRICATION &amp; KITCHEN</p>
          <h1>
            โรงงานสแตนเลส<br/>
            ที่มีประสบการณ์<br/>
            ยาวนานกว่า <span>30 ปี</span>
          </h1>
          <p className="hero-summary">
            ผลิต นำเข้า และจำหน่ายเครื่องครัวครบวงจร
          </p>

          <div className="hero-actions">
            <Link to="/contact" className="hero-primary-action">
              ปรึกษาโปรเจกต์ของคุณ <FaArrowRight />
            </Link>
            <button type="button" className="hero-secondary-action" onClick={scrollToSection}>
              ดูบริการของเรา <FaArrowDown />
            </button>
          </div>
        </div>

        <div
          className="home-hero-visual home-hero-image"
          role="region"
          aria-roledescription="carousel"
          aria-label="ภาพตัวอย่างระบบครัวเชิงพาณิชย์"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div
            className="hero-slide-track"
            style={{ transform: `translateX(-${heroSlide * 100}%)` }}
          >
            {heroSlides.map((slide, index) => (
              <div
                className="hero-slide"
                key={slide.src}
                aria-hidden={heroSlide !== index}
              >
                <img src={slide.src} alt={heroSlide === index ? slide.alt : ""} />
              </div>
            ))}
          </div>

          <div className="hero-slider-controls">
            <button type="button" onClick={showPreviousSlide} aria-label="ภาพก่อนหน้า">
              <FaArrowLeft />
            </button>
            <div className="hero-slider-dots">
              {heroSlides.map((slide, index) => (
                <button
                  type="button"
                  key={slide.src}
                  className={heroSlide === index ? "active" : ""}
                  onClick={() => setHeroSlide(index)}
                  aria-label={`แสดงภาพที่ ${index + 1}`}
                  aria-current={heroSlide === index ? "true" : undefined}
                ></button>
              ))}
            </div>
            <button type="button" onClick={showNextSlide} aria-label="ภาพถัดไป">
              <FaArrowRight />
            </button>
          </div>
        </div>

        <div className="hero-metrics">
          <div><strong>ผลิตตามแบบ</strong><span>ยึดตามสเปคของลูกค้า</span></div>
          <div><strong>ทั่วประเทศ</strong><span>พร้อมบริการทุกพื้นที่</span></div>
          <div><strong>โรงงานตรง</strong><span>ควบคุมคุณภาพทุกขั้นตอน</span></div>
        </div>
      </section>

      <div className="services" id="services">
        <div className="services-header-container">
          <h2>บริการของเรา</h2>
          <div>
            <p style={{fontSize:'14px', color: '#6F6F6F', paddingTop: '7px', maxWidth: '880px'}}
            className="services-des">
              งานห้องครัวทุกประเภทครบวงจร ตั้งแต่ ผลิต ติดตั้ง ให้คำปรึกษา มีสินค้าครบทุกประเภท สามารถผลิตหรือนำเข้า
              จากต่างประเทศ ขึ้นงานสแตนเลสและเหล็กได้อย่างแม่นยำ
              และตรงตามสเปค
            </p>
            <Link to="/contact">
            <p style={{color: '#16409A'}} className="sevices-advice">ขอคำแนะนำจากผู้เชี่ยวชาญ <FaArrowRight className="right-icon" /></p>
            </Link>
          </div>
        </div>

        <div className="services-container">
          <div>
            <img src={require("../images/services-previews.png")} alt="" />
            <h3>ติดตั้งระบบดูดอากาศในห้องครัว</h3>
            <Link to="/service1">
            <p>ดูรายละเอียดเพิ่มเติม <FaArrowRight className="right-icon" /></p>
            </Link>
          </div>

          <div>
            <img src={require("../images/services-previews-gas.jpg")} alt="" />
            <h3>ติดตั้งระบบแก๊สและระบบความปลอดภัย</h3>
            <Link to="/service2">
            <p>ดูรายละเอียดเพิ่มเติม <FaArrowRight className="right-icon" /></p>
            </Link>
          </div>
          
          <div>
            <img src={require("../images/services-previews-3.jpg")} alt="" />
            <h3>ผลิตและนำเข้าเครื่องครัวครบวงจร</h3>
            <Link to="/service3">
            <p>ดูรายละเอียดเพิ่มเติม <FaArrowRight className="right-icon" /></p>
            </Link>
          </div>
          
          <div>
            <img src={require("../images/services-previews.png")} alt="" />
            <h3>งานผลิตสแตนเลสและเหล็กตามแบบ</h3>
            <Link to="/service4">
            <p>ดูรายละเอียดเพิ่มเติม <FaArrowRight className="right-icon" /></p>
            </Link>
          </div>
         
        </div>
      </div>

      <div className="why-us">
        <div className="why-us-overall-container">
          <div>
            <h1>ทำไมต้องเลือกเรา ?</h1>
            <p style={{fontSize:'14px', paddingTop: '10px'}}>
              เพราะเรามีประสบการณ์กว่า 30 ปี สินค้าคุณภาพสูง <br />
              ราคาเป็นมิตร รับประกันจริง มีหน้าร้านจริง เชื่อถือได้ <br />
              และบริการจัดส่งทั่วประเทศ รวดเร็ว มั่นใจได้
            </p>
          </div> 
        </div>
        
        <div className="flex-whyUs-container">
          
          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>จบครบในที่เดียว</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                ครบทุกเรื่อง ตั้งแต่ให้คำปรึกษา <br />
                ผลิต ติดตั้ง ไปจนถึงจัดหาอุปกรณ์
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>ให้คำปรึกษาโดยผู้เชี่ยวชาญ</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                มีผู้เชี่ยวชาญโดยเฉพาะ <br />
                ทางด้านระบบห้องครัว สแตนเลสและโลหะ
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>ประสบการณ์กว่า 30 ปี</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                โรงงานเราเปิดมายาวนาน ทำให้มีความเชี่ยวชาญ <br />
                ในด้านระบบห้องครัว สแตนเลสและโลหะ
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>มาตรฐานดีเยี่ยม ราคาย่อมเยา</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                ใช้สแตนเลส และโลหะคุณภาพดีใช้งานได้จริง <br />
                ในราคาที่ย่อมเยาและคุ้มค่า
              </p>
            </div>
          </div>

          <div className="whyUs-container">
            <FaCheck className="check-icon" />
            <div>
              <h2>รับประกันและบริการทั่วไทย</h2>
              <p style={{fontSize: '14px', lineHeight: '18px'}}>
                รับประกันทุกชิ้นงานจากโรงงาน <br />
                บริการติดตั้งและจัดส่งทั่วประเทศไทย
              </p>
            </div>
          </div>
        
        </div>

      </div>

      <div className="company-des">
        <img src={require("../images/company-banner.png")} alt="" className="company-img"/>
        <div className="company-des-container">
          <img src={logoBlue} alt="POWER BUNCH" />
          <p style={{marginTop: '25px', lineHeight: '19px'}}>
            Power Bunch เป็นบริษัทที่ดำเนินธุรกิจ
            มายาวนานกว่า 30 ปี เราให้ความสำคัญกับ
            ความซื่อสัตย์และความจริงใจในการค้าขาย พร้อมให้บริการลูกค้าด้วยมาตรฐานที่ชัดเจน
            และโปร่งใส มีหน้าร้านจริง สามารถเข้าชม
            สินค้าได้ทุกวัน เรามุ่งมั่นให้บริการที่ดีที่สุด
            เพื่อให้ลูกค้ามั่นใจในคุณภาพของสินค้า
          </p>
          <Link to="/about" className="about-link">
          อ่านเรื่องราวของเราเพิ่มเติม
          <FaArrowRight/>
          </Link>
        </div>
      </div>

      <section className="facebook-feed-section" aria-labelledby="facebook-feed-title">
        <div className="facebook-feed-copy">
          <h2 id="facebook-feed-title">ติดตามผลงานล่าสุด<br />จาก Power Bunch</h2>
          <p className="facebook-feed-description">
            ดูตัวอย่างงานติดตั้ง ข่าวสาร และอัปเดตจากโรงงานผ่าน Facebook ของเรา
          </p>

          <a
            href="https://www.facebook.com/profile.php?id=61550302584763"
            target="_blank"
            rel="noopener noreferrer"
            className="facebook-page-link"
          >
            เปิดหน้า Facebook <FaArrowRight />
          </a>
        </div>

        <div className="facebook-feed-embed">
          <div className="facebook-embed-header">
            <span className="facebook-mark">f</span>
            <div>
              <strong>Power Bunch</strong>
              <span>Facebook Updates</span>
            </div>
            <a
              href="https://www.facebook.com/profile.php?id=61550302584763"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="เปิด Facebook ของ Power Bunch"
            >
              <FaArrowRight />
            </a>
          </div>
          <iframe
            title="Facebook feed ของ Power Bunch"
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61550302584763&tabs=timeline&width=500&height=620&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false"
            width="500"
            height="620"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        </div>

        <div className="facebook-reels-block">
          <div className="facebook-reels-heading">
            <div>
              <p className="facebook-feed-eyebrow">LATEST REELS</p>
              <h3>วิดีโอแนะนำ</h3>
            </div>
            <a
              href="https://www.facebook.com/profile.php?id=61550302584763"
              target="_blank"
              rel="noopener noreferrer"
            >
              ดูทั้งหมดบน Facebook <FaArrowRight />
            </a>
          </div>

          <div className="facebook-reels-grid">
            {[
              "https://www.facebook.com/reel/1055176846852005",
              "https://www.facebook.com/reel/1958812618147900",
              "https://www.facebook.com/reel/2022985501649830",
              "https://www.facebook.com/reel/844309985205608",
            ].map((reelUrl, index) => (
              <article className="facebook-reel-card" key={reelUrl}>
                <div className="facebook-reel-frame">
                  <iframe
                    title={`Power Bunch Facebook Reel ${index + 1}`}
                    src={`https://www.facebook.com/plugins/video.php?height=476&href=${encodeURIComponent(reelUrl)}&show_text=false&width=267&t=0`}
                    width="267"
                    height="476"
                    style={{ border: "none", overflow: "hidden" }}
                    scrolling="no"
                    frameBorder="0"
                    allowFullScreen
                    loading="lazy"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  ></iframe>
                </div>
                <div className="facebook-reel-footer">
                  <span>REEL {String(index + 1).padStart(2, "0")}</span>
                  <a href={reelUrl} target="_blank" rel="noopener noreferrer" aria-label={`เปิด Reel ${index + 1} บน Facebook`}>
                    <FaArrowRight />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>

      </section>

      {/* <div className="partner">
        <h1><span style={{color: '#16409A'}}>ลูกค้า</span>ของเรา</h1>
        <div className="partner-grid">
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
        </div>
      </div> */}
      
    </div>
    
  );
}

export default Home;
